console.log('custom.js loaded');

/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/* When the user clicks on the header language switcher button,
toggle between hiding and showing the dropdown content */
function openLangDropdown() {
    document.getElementById("header-lang-dropdown").classList.toggle("show");
}

function openMobileLangDropdown() {
    document.getElementById("mobile-lang-dropdown").classList.toggle("show");
}
  
// Close the dropdown menu if the user clicks outside of it
window.onclick = function(event) {

    if (!event) return;

    // Some browsers/events can yield a non-element target (or even a text node)
    var target = event.target || event.srcElement;
    if (!target) return;
    if (target.nodeType === 3) target = target.parentNode; // TEXT_NODE -> element

    if (!target || target.nodeType !== 1) return;

    // Header language dropdown
    if (!target.closest('.header-lang-dropdown-container')) {
        var dropdowns = document.getElementsByClassName("header-lang-dropdown__content");
        var i;
        for (i = 0; i < dropdowns.length; i++) {
        var openDropdown = dropdowns[i];
        if (openDropdown.classList.contains('show')) {
            openDropdown.classList.remove('show');
        }
        }
    }

    // Mobile menu language dropdown
    if (!target.closest('.mobile-lang-dropdown-container')) {
        var dropdowns = document.getElementsByClassName("mobile-lang-dropdown__content");
        var i;
        for (i = 0; i < dropdowns.length; i++) {
        var openDropdown = dropdowns[i];
        if (openDropdown.classList.contains('show')) {
            openDropdown.classList.remove('show');
        }
        }
    }
};

/**
 * Hide header on scroll down, show on scroll up (with buffer)
 *
 * - Only applies when the theme header is sticky (`<store-header sticky>`)
 * - Uses a 50px buffer to avoid accidental toggles
 */
(function () {
    // Persistent marker so you can verify initialization without relying on console timing
    window.__AARIKKA_HEADER_SCROLL__ = 'script-loaded';

    const BUFFER_PX = 50;
    const HIDDEN_CLASS = 'header--scroll-hidden';

    var lastScrollY = window.scrollY || 0;
    var lastDirection = null; // 'up' | 'down'
    var directionDistance = 0;
    var ticking = false;
    var debugLogged = false;

    function getStickyHeader() {
        return document.querySelector('store-header.header[sticky]');
    }

    function shouldApplyHideThreshold() {
      
        var main = document.getElementById('main');
        if (!main) return false;

        var first = main.firstElementChild;
        if (!first) return false;

        return first.classList.contains('shopify-section') && first.classList.contains('shopify-section--slideshow');
    }

    function parsePx(value) {
        if (!value) return 0;
        return parseFloat(String(value).replace('px', '')) || 0;
    }

    function getHideThresholdPx(header) {
        // Prefer CSS variables (kept up to date by theme), fall back to DOM measurements
        var styles = window.getComputedStyle(document.documentElement);
        var headerHeight = parsePx(styles.getPropertyValue('--header-height'));

        if (!headerHeight && header) {
            headerHeight = header.getBoundingClientRect().height || 0;
        }

        // Only include announcement height when it's sticky (theme exposes enable var as 0/1)
        var enableStickyAnnouncement = parseFloat(styles.getPropertyValue('--enable-sticky-announcement-bar')) || 0;
        var announcementHeight = 0;

        if (enableStickyAnnouncement) {
            announcementHeight = parsePx(styles.getPropertyValue('--announcement-bar-height'));
            if (!announcementHeight) {
                var announcementEl = document.querySelector('announcement-bar.announcement-bar');
                if (announcementEl) announcementHeight = announcementEl.getBoundingClientRect().height || 0;
            }
        }

        return headerHeight + announcementHeight;
    }

    function showHeader(header) {
        if (header) header.classList.remove(HIDDEN_CLASS);
    }

    function hideHeader(header) {
        if (header) header.classList.add(HIDDEN_CLASS);
    }

    function update() {
        ticking = false;

        var header = getStickyHeader();
        if (!header) return;

        // If a drawer is open, keep header visible (theme uses lock-all to lock scroll)
        if (document.documentElement.classList.contains('lock-all')) {
            directionDistance = 0;
            lastDirection = null;
            showHeader(header);
            lastScrollY = window.scrollY || 0;
            return;
        }

        var currentY = window.scrollY || 0;
        var delta = currentY - lastScrollY;

        // Only apply "don't hide until past header stack height" when hero is a slideshow
        var hideThresholdPx = shouldApplyHideThreshold() ? getHideThresholdPx(header) : 0;

        if (currentY <= hideThresholdPx) {
            directionDistance = 0;
            lastDirection = null;
            showHeader(header);
            lastScrollY = currentY;
            return;
        }

        // Ignore tiny scroll noise
        if (Math.abs(delta) < 1) {
            lastScrollY = currentY;
            return;
        }

        var direction = delta > 0 ? 'down' : 'up';
        if (direction !== lastDirection) {
            directionDistance = 0;
            lastDirection = direction;
        }

        directionDistance += Math.abs(delta);

        if (directionDistance >= BUFFER_PX) {
            if (direction === 'down') {
                hideHeader(header);
            } else {
                showHeader(header);
            }

            // Reset after toggling so a small bounce doesn’t immediately toggle back
            directionDistance = 0;
        }

        lastScrollY = currentY;
    }

    function onScroll() {
        if (!debugLogged && window.console && console.log) {
            console.log('custom header scroll active');
            debugLogged = true;
        }

        if (!ticking) {
            window.requestAnimationFrame(update);
            ticking = true;
        }
    }

    function init() {
        var header = getStickyHeader();
        if (!header) {
            window.__AARIKKA_HEADER_SCROLL__ = 'no-sticky-header';
            return;
        }

        window.__AARIKKA_HEADER_SCROLL__ = 'initialized';

        // Ensure we start visible
        showHeader(header);
        lastScrollY = window.scrollY || 0;
        lastDirection = null;
        directionDistance = 0;

        window.addEventListener('scroll', onScroll, { passive: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();